import { Button, EmptyState } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <main className="grid min-h-dvh place-items-center p-6">
      <EmptyState
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <Button type="button" variant="primary" onClick={() => navigate('/')}>
            {t('notFound.back')}
          </Button>
        }
      />
    </main>
  );
}
